module.exports = __webpack_public_path__ + "img/generated-1772425752939.568d2f3d.png";